import { render, staticRenderFns } from "./TevaSlider.vue?vue&type=template&id=6dbc7f8b&"
import script from "./TevaSlider.vue?vue&type=script&lang=js&"
export * from "./TevaSlider.vue?vue&type=script&lang=js&"
import style0 from "./TevaSlider.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports